import { usePdfTextExtraction } from "../../Utils/usePdfTextExtraction";

/**
 * Pages of the open document matching the search term, plus extraction
 * progress for the search box.
 *
 * Takes the PDFDocumentProxy the viewer's <Document> already resolved rather
 * than a URL, so searching reuses that transport instead of opening a second
 * download of the same file.
 *
 * @param {import("pdfjs-dist").PDFDocumentProxy|null} pdfDoc
 * @param {string} searchString
 */
export const usePdfTextSearch = (pdfDoc, searchString) =>
  usePdfTextExtraction(pdfDoc, searchString);
